"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PastOrders = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = _interopRequireWildcard(require("react"));

var _formatters = require("formatters");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _Orders = babelHelpers.interopRequireDefault(require("Orders"));

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _class, _descriptor, _descriptor2, _class3, _descriptor3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PastOrdersPage = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(PastOrdersPage, _Component2);

  var _super2 = _createSuper(PastOrdersPage);

  function PastOrdersPage() {
    var _this2;

    babelHelpers.classCallCheck(this, PastOrdersPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor3, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(PastOrdersPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container"
      }, /*#__PURE__*/_react.default.createElement(PastOrders, this.content));
    }
  }]);
  return PastOrdersPage;
}(_react.Component), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = PastOrdersPage;
var PastOrders = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(PastOrders, _Component);

  var _super = _createSuper(PastOrders);

  function PastOrders() {
    var _this;

    babelHelpers.classCallCheck(this, PastOrders);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "orderList", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "clientName", _descriptor2, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(PastOrders, [{
    key: "render",
    value: function render() {
      var _this$clientName, _this$orderList;

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack header-block",
        "data-block-type": "header",
        "data-block-id": "pastOrderHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "spotlight-header variable-background",
        style: _base.default.styleForBackgroundObject({
          landscape: '/images/prositebgdefault1400x900.jpg',
          portrait: '/images/prositebgdefault1400x900.jpg',
          imageOverlay: 'none'
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Past Orders"), /*#__PURE__*/_react.default.createElement("h2", null, (_this$clientName = this.clientName) !== null && _this$clientName !== void 0 ? _this$clientName : "Need help? 503-906-8148 for assistance.")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": (_this$orderList = this.orderList) !== null && _this$orderList !== void 0 && _this$orderList.length ? 'pastOrders' : 'emptyPastOrders'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement(_Orders.default, {
        orderList: this.orderList
      }))));
    }
  }]);
  return PastOrders;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "clientName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.PastOrders = PastOrders;